import { useQuery } from '@tanstack/react-query'

import { components } from '~/clients/optimus-api-types.generated'
import api from '~/clients/optimus-client'
import { handleApiRequest } from '~/hooks/tanstack-query/optimus/shared/apiWrapper'

export const useApplyRecurringAssignmentsQuery = (data: components['schemas']['RecurringAssignmentApplyRequest']) =>
    useQuery({
        queryKey: ['previewRecurringAssignments', data.preview, data.start_date, data.end_date, ...data.recurring_assignment_uuids],
        queryFn: async () => handleApiRequest(() => api.recurringAssignments.apply(data)),
    })
